import React, { useEffect, useContext, useState } from "react";
import { ScreenView, TokenVerificationLoggedin } from "../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import FullLoader from "../assets/images/full-page-loader.gif"

const Dashboard = () => {
  const loadingContext = useContext(LoadingContext);
  const [step, setStep] = useState(0)

  useEffect(() => {
    TokenVerificationLoggedin();
    ScreenView()
    setTimeout(() => {
      setStep(1)
    }, 300)
    loadingContext.done()
  }, [loadingContext]);


  if (step === 0) {
    return (
      <div
        style={{ width: "100%", height: "100vh" }}
        className="d-flex justify-content-center align-items-center"

      >
        <img
          // src="https://media0.giphy.com/media/3oEjI6SIIHBdRxXI40/200w.gif?cid=6c09b952jdpo41hluthq9teb8zgvi4pdqaa1nt4htgdj4ghl&ep=v1_gifs_search&rid=200w.gif&ct=g" 
          src={FullLoader}
          width={50}
          height={50}
          alt="" />
      </div>
    )
  }
  else {
    return (


      <div className="container_box--wrapper pt_header">
        <div className="container_box--wrapper--title d_flex justify-content-between">
          <h1 className="heading fw_600">
            Dashboard
          </h1>
        </div>
      </div>
      // <>
      // <h2 
      // style={{position:"absolute",top:"100px",left:"20px"}}
      // >Dashboard</h2>
      // </>
    );
  }
};

export default Dashboard;
